import MoreActionsMenu from "@/modules/common/components/ui-kit/menus/more-actions-menu";
import { EnvironmentVariables } from "@/modules/common/types";
import { MenuItem, Typography } from "@mui/material";

export const TerminateContractAction = ({
  contractUid,
  onClose,
}: Readonly<{ contractUid: string; onClose?: () => void }>) => {
  const handleTerminateContract = () => {
    const url = `${EnvironmentVariables.CONTRACTS_FRONTEND_URL}/contracts?action=terminate&search=${contractUid}`;
    window.open(url, "_blank");
    onClose?.();
  };
  return (
    <MenuItem onClick={handleTerminateContract}>
      <Typography color="error" fontSize={14}>
        Terminate Contract
      </Typography>
    </MenuItem>
  );
};

export const ExtendContractAction = ({
  contractUid,
  endDate,
  onClose,
}: Readonly<{
  contractUid: string;
  endDate: string;
  onClose?: () => void;
}>) => {
  const checkIfEndDateIsInThreeMonths = (date: string) => {
    const threeMonthsFromNow = new Date();
    threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);
    if (new Date(date) <= threeMonthsFromNow) {
      return false;
    }
    return true;
  };

  const handleExtendContract = () => {
    if (checkIfEndDateIsInThreeMonths(endDate)) {
      const url = `${EnvironmentVariables.CONTRACTS_FRONTEND_URL}/contracts?action=extend&search=${contractUid}`;
      window.open(url, "_blank");
      onClose?.();
    }
  };

  return (
    <MenuItem
      onClick={handleExtendContract}
      disabled={!checkIfEndDateIsInThreeMonths(endDate)}
    >
      <Typography fontSize={14}>Extend Contract</Typography>
    </MenuItem>
  );
};

function ContractActionsMenu({
  contractUid,
  endDate,
}: Readonly<{ contractUid: string; endDate: string }>) {
  return (
    <MoreActionsMenu>
      <ExtendContractAction contractUid={contractUid} endDate={endDate} />
      <TerminateContractAction contractUid={contractUid} />
    </MoreActionsMenu>
  );
}

export default ContractActionsMenu;
